import config from "../../../config"
import { storeDataDownloadFiles, storeDataDownloadFilesClone } from '../../Reducers/Administrator/DownloadFiles'
import { notification } from 'antd'

const notificacionServidor = (type, mensaje) => {
    if(type === 'success'){
        notification['success']({
            message: 'Éxito',
            description: mensaje,
        })
    }else if(type === 'warning'){
        notification['warning']({
            message: 'Advertencia',
            description: mensaje,
        })
    }else if(type === 'error'){
        notification['error']({
            message: 'Error',
            description: mensaje,
        })
    }
}

export const GetDownloadFilesServices = async (dispatch) => {
    await fetch(config.api_url+`downloads-files/get-download-files`, {
        mode:'cors',
        method: 'GET',
        headers: {
            'Accept' : 'application/json',
            'Content-type' : 'application/json',
            'usutoken': localStorage.getItem('usutoken'),
        },
    })
    .then(res => res.json())
    .then(async data => {
        if(data.response){
            const data_download_files = data.data
            data_download_files.map((aud, index) => {
                data_download_files[index]['key'] = index + 1
            })
            dispatch(storeDataDownloadFiles(data_download_files))
            dispatch(storeDataDownloadFilesClone(data_download_files))

            notificacionServidor('success', data.message)
        }else{
            notificacionServidor('warning', data.message)
            throw new Error(`${data.message}`)
        }
    })
    .catch(error => {
        console.log(error)
        throw new Error('Los sentimos hubo un error en el servidor.')
    })

    return true
}